import styled from 'styled-components'

export const Wrapper = styled.div`
  button {
    margin: 3px;
    width: 74px;
  }
`
